import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class CloudNamesService {
  constructor(private apiService: ApiService) {}

  getZiaCloudNames() {
    return this.apiService.get('/cloudnames/zia');
  }

  getZpaCloudNames() {
    return this.apiService.get('/cloudnames/zpa');
  }
}
